import { displayToastError, http } from 'app';

export const getCoverageCheckV2 = async (
  businessArea: string,
  service: string,
  body: any
): Promise<any> => {
  try {
    const response = await http.post(
      '/v2/:businessArea/:service'
        .replace(':businessArea', businessArea)
        .replace(':service', service),
      body,
      {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    );
    return response.data;
  } catch (error: any) {
    if (error.response.data.statusCode === 422) {
      const newBody = body;
      newBody.set('ignoreCache', true);
      try {
        const response = await http.post(
          '/v2/:businessArea/:service'
            .replace(':businessArea', businessArea)
            .replace(':service', service),
          newBody,
          {
            headers: { 'Content-Type': 'multipart/form-data' }
          }
        );
        return response.data;
      } catch (error: any) {
        const errorMessage = error.response.data.message;
        displayToastError(String(errorMessage), 'Get Extraction');
        throw new Error();
      }
    } else {
      const errorMessage = error.response.data.message;
      displayToastError(String(errorMessage), 'Get Extraction');
      throw new Error();
    }
  }
};
